import { Injectable } from '@angular/core';
import { Alert } from '../model/Alert';

@Injectable({
  providedIn: 'root'
})
export class AlertsService {

  constructor() { }

  alerts: Alert[] = [];

  add(message: string, messageType: string, debug: string) {
    this.alerts.push({message: message, messageType: messageType, debug: debug});
  }

  remove(alert: Alert) {
    this.alerts.splice(this.alerts.indexOf(alert), 1);
  }
}
